import http from "../jslibs/axios/http";

// 财务汇总列表
export const financeList = (data) => http.get("/v1/cms/Trade", data);
// 对公账户信息
export const accountMsg = (data) => http.get("/v1/cms/TrainOption", data);
// 编辑 对公账户信息
export const accountMsgEdit = (data) => http.post("/v1/cms/TrainOption", data);
// 财务统计
export const financeView = (data) => http.get("/v1/cms/TradeCount", data);
// 财务导出
export const financeExport = (data) => http.down(`/v1/cms/TradeExport`, data);

// 用户统计
export const userList = (data) => http.get("/v1/cms/UserTj", data);
// 用户统计折线图
export const userListLine = (data) => http.get("/v1/cms/UserTjLine", data);
// 用户导出
export const userExport = (data) => http.down(`/v1/cms/UserTjExport`, data);

// 证书统计
export const certificateList = (data) => http.get("/v1/cms/CertificateTj", data);
// 证书统计-饼图
export const certificateLine = (data) => http.get("/v1/cms/CertificateTjLine", data);

// 首页统计
export const indexData = (data) => http.get("/v1/cms/Tongji", data);

// 敏感词库
// 词库列表
export const binaryList = (data) => http.get("/v1/cms/WordCate", data);
// 新增
export const binaryAdd = (data) => http.post("/v1/cms/WordCate", data);
// 删除
export const binaryDel = (id) => http.delete(`/v1/cms/WordCate/${id}`);
// 编辑
export const binaryEdit = (data, id) => http.put(`/v1/cms/WordCate/${id}`, data);
// 敏感词
// 词列表
export const wordList = (data) => http.get("/v1/cms/WordName", data);
// 新增
export const wordAddBathc = (data) => http.post("/v1/cms/WordNameBatch", data);
export const wordAdd = (data) => http.post("/v1/cms/WordName", data);
// 删除
export const wordDel = (id) => http.delete(`/v1/cms/WordName/${id}`);
// 编辑
export const wordEdit = (data, id) => http.put(`/v1/cms/WordName/${id}`, data);

// 获取学员数据预览
export const getStudentOverviewData = (data) => http.post("/v1/cms/Archive/counts", data);
// 用户数据导出
export const userDataExport = (data) => http.post(`/v1/cms/Archive/counts`, data);
// 获取用户趋势数据
export const getStudentTrendData = (data) => http.post("/v1/cms/Archive/day_counts", data);
// 用户趋势导出
export const userTrendExport = (data) => http.post(`/v1/cms/day_counts_export`, data);
